import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.user,
    props.user.buttons.changePassword,
    (user, changePasswordButton) => {
        return {
            user,
            changePasswordButton
        }
    }
)